import { GosuslugiButton } from './gosuslugi-button';
import styles from './questionnaire-form-header.module.scss';

type QuestionnaireFormHeaderProps = { onEsiaRedirectAction: () => void; isLoading?: boolean };

export const QuestionnaireFormHeader = ({ onEsiaRedirectAction, isLoading }: QuestionnaireFormHeaderProps) => {
  return (
    <div className={styles.headerBlock}>
      <div className={styles.titles}>
        <div className={styles.title}>Анкета соискателя</div>
        <div className={styles.subtitle}>Заполните анкету или войдите через Госуслуги</div>
      </div>
      <GosuslugiButton className={styles.gosuslugiButton} forceCompact disabled={isLoading} onClick={onEsiaRedirectAction} />
    </div>
  );
};
